"use client";

import Image from "next/image";
import React, { useEffect, useRef, useState } from "react";
import "./MultipleCryptocurrencies.css";

const MultipleCryptocurrencies = ({ path, content }) => {
    const sliderRef = useRef(null);
    const [isPaused, setIsPaused] = useState(false);

    useEffect(() => {
        // Clone items for the infinite scroll effect
        const slider = sliderRef.current;
        if (!slider || !content?.services?.length) return;

        // Set the CSS variable for animation duration - reduced from 15 to 10 seconds per item for faster speed
        slider.style.setProperty(
            "--animation-duration",
            `${content?.services.length * 3}s`
        );

        // Clone the first set of items and append to the end for seamless looping
        const items = slider.querySelectorAll(".crypto-item");
        const clonedItems = Array.from(items).map((item) =>
            item.cloneNode(true)
        );
        clonedItems.forEach((item) => {
            slider.appendChild(item);
        });

        // Start the animation
        slider.classList.add("sliding");

        // Reset the animation when it completes
        const handleAnimationEnd = () => {
            slider.classList.remove("sliding");
            slider.style.transform = "translateX(0)";
            setTimeout(() => {
                slider.classList.add("sliding");
            }, 10);
        };

        slider.addEventListener("animationend", handleAnimationEnd);

        return () => {
            slider.removeEventListener("animationend", handleAnimationEnd);
        };
    }, [content?.services]);

    if (!content?.services?.length) return null;

    const handleMouseEnter = () => {
        setIsPaused(true);
    };

    const handleMouseLeave = () => {
        setIsPaused(false);
    };

    return (
        <div className="md:mt-24 sm:mt-20 mt-16">
            <div className="overflow-hidden w-full">
                {content?.title && (
                    <h2
                        className={`text-2xl lg:text-5xl leading-snug font-bold font-mono text-[#410EAD] px-7 2xl:px-[200px] xl:px-32 lg:px-20 2xl:text-start text-center`}
                    >
                        {content?.title}
                    </h2>
                )}

                <div
                    ref={sliderRef}
                    className="flex items-center gap-4 slider-container md:my-10 my-8"
                    style={{
                        animationPlayState: isPaused ? "paused" : "running",
                    }}
                    onMouseEnter={handleMouseEnter}
                    onMouseLeave={handleMouseLeave}
                >
                    {content?.services?.map((item, index) => {
                        return (
                            <div
                                key={index}
                                className="crypto-item flex-shrink-0 flex flex-col justify-center items-center sm:gap-3 gap-2.5 bg-white border border-[#EBEFF6] rounded-[14.5px] py-5 px-16 transition-all duration-300"
                                style={{
                                    boxShadow: "0px 4px 24px 0px #0000002B",
                                }}
                            >
                                <Image
                                    src={`/assets/${path}/${item?.image}.webp`}
                                    alt={item?.alt}
                                    width={70}
                                    height={70}
                                    className="w-[70px] h-[70px] object-contain"
                                />
                                <p className="whitespace-nowrap font-mono font-bold text-[22px] text-black text-center">
                                    {item?.title}
                                </p>
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};

export default MultipleCryptocurrencies;
